

<div class="flex-column gap-2">

	<!--loader-->
	<div class="f-1-0 flex-column centralize" *ngIf="!config && getThreatPreventionRulesInProcess">
		<loader height="100" width="100" style="opacity: 0.8;"></loader>
	</div>

	<div class="list-group list-group-flush settings-list-container" *ngIf="config">
		<!--Settings: Email actions-->
		<div class="list-group-item column-style settings-list-item gap-3">
			<div class="title-section-container flex-column gap-2">
				<b>Email Category Actions</b>
			</div>
			<div class="content-container flex-column gap-1 p-2 bg-light mb-3" style="z-index: 50;">
				<div class="flex-row align-items-center bg-white p-2 gap-2">
					<div class="flex-row align-items-center gap-1">
						<span>Select actions preset:</span>
						<i style="font-weight: 400;" class="far fa-question-circle" tooltip='The "Main" rule preset will be used by default. You can custom presets here that can be used according to inbound email rules.'></i>
					</div>
					<app-dropdown-c style="width: 250px;" [isEllipsis]="true"
									[text]="selectedRulePreset?.name"
									[items]="rulePresets"
									itemDisplayKey="name" [enableSearch]="true"
									(onItemClicked)="selectedRulePreset = $event.item; expandedRuleType = null">
					</app-dropdown-c>
					<div></div><!--padder-->
					<btn-c style="min-width: 0;"
						   btnTooltip="Add new rules preset"
						   variant="outlined"
						   (action)="openAddSubRulePopup();">
						Add
					</btn-c>
					<btn-c style="min-width: 0;"
						   btnTooltip="Create a clone of the selected preset"
						   variant="outlined"
						   (action)="openCloneSubRulePopup();">
						Clone
					</btn-c>
					<div class="vertical-separator opacity-25 h-auto align-self-stretch mx-1"></div>
					<btn-c btnTooltip='Set threat prevention rules to "Monitor mode"'
						   class="show-in-o-wizard"
						   variant="outlined"
						   (action)="monitorInboundRules();">
						Monitor mode
					</btn-c>
					<btn-c style="min-width: 0;"
					       class="show-in-o-wizard"
					       *ngIf="selectedRulePreset?.name === dic.CONSTANTS.lfMainCustomizationName"
						   btnTooltip="Reset the threat prevention rules to the default settings, in selected preset"
						   variant="outlined"
						   (action)="resetInboundRules();">
						Reset
					</btn-c>
					<btn-c class="animated fadeIn" style="min-width: 0;"
						   *ngIf="selectedRulePreset?.name !== dic.CONSTANTS.lfMainCustomizationName"
						   btnTooltip="Delete selected threat prevention rules preset"
						   variant="outlined" color="danger"
						   (action)="deleteSubRule();">
						Delete
					</btn-c>
				</div>

				<div class="bg-white py-2 px-3 show-in-o-wizard">
					<!--CC: quiet uppercase column labels - the bold 15px headers competed with the row content-->
					<div class="flex-row align-items-center p-2 pb-0 mt-3" style="font-size: 11.5px; font-weight: 600; letter-spacing: 0.4px; text-transform: uppercase; color: var(--ui-text-muted);">
						<span style="width: 210px; flex-shrink: 0;">Detection Category</span>
						<span style="width: 130px;">
							Actions
						</span>
						<span class="f-1-0"></span>
						<span class="flex-row align-items-center gap-1" style="min-width: 135px;"
							  *ngIf="!selectedRulePreset || selectedRulePreset?.name === dic.CONSTANTS.lfMainCustomizationName">
							Retention Period
							<i style="font-weight: 400;" class="far fa-question-circle" tooltip="Determine how long email records will be kept by Trustifi."></i>
						</span>
						<span style="width: 28px;"></span>
					</div>

					<div class="flex-column gap-2 mt-2" *ngIf="selectedRulePreset">
						<div *ngFor="let ruleType of dic.CONSTANTS.tpRule.name | keyvalue: gs.returnZero"
							[ngClass]="{'shadow-sm border-dark' : expandedRuleType === ruleType.key}"
							class="flex-column rounded border" style="transition: all 0.2s;">

							<div class="flex-row align-items-center gap-2" style="cursor: pointer;"
								(click)="expandedRuleType = expandedRuleType === ruleType.key ? null : ruleType.key">

								<div class="flex-row align-items-center gap-1 ps-2 py-3" style="width: 210px; flex-shrink: 0;">
									<!--CC: severity icon matching quarantined-email-action pattern-->
									<i class="far flex-shrink-0"
									   style="font-size: 11px; opacity: 0.65;"
									   [ngClass]="ruleType.value === dic.CONSTANTS.tpRule.name.malicious ? 'fas fa-biohazard' : ruleType.value === dic.CONSTANTS.tpRule.name.suspicious ? 'fa-exclamation-triangle' : ruleType.value === dic.CONSTANTS.tpRule.name.external ? 'fa-external-link-alt' : 'fa-exclamation-circle'"
									   [ngStyle]="{'color': (ruleType.value === dic.CONSTANTS.tpRule.name.malicious || ruleType.value === dic.CONSTANTS.tpRule.name.suspicious) ? 'var(--ui-danger)' : ruleType.value === dic.CONSTANTS.tpRule.name.graymail ? 'var(--ui-text-subtle)' : 'var(--ui-warning)'}">
									</i>
									<span class="fw-500 text-capitalize ms-1" style="font-size: 14px; color: var(--ui-text);">
										{{ruleType.value === dic.CONSTANTS.tpRule.name.external ? 'external/unfamiliar' : ruleType.value}}
									</span>
									<i style="font-weight: 400;" class="far fa-question-circle text-muted"
										[tooltip]="ruleTypesTooltips[ruleType.value]"></i>
								</div>
								<app-dropdown-c style="width: 130px;"
									(click)="$event.stopPropagation();"
									text="<span class='{{selectedRulePreset[ruleType.key].actions.includes(rulesMainActions.release) ? 'text-success' : 'text-danger'}}'>{{selectedRulePreset[ruleType.key].actions.includes(rulesMainActions.release) ? rulesMainActions.release : rulesMainActions.quarantine}}</span>">
									<li *ngFor="let actionKey of rulesMainActions | keyvalue: gs.returnZero"
										[explanationC]="dic.CONSTANTS.tpRule.actionTooltip[actionKey.key]"
										(click)="showRulePrimaryActionsPopup(ruleType.key, actionKey.value);">
										{{actionKey.value}}
									</li>
								</app-dropdown-c>
								<div class="flex-row align-items-center gap-1 py-2 flex-wrap justify-content-start px-3 f-1-0" style="min-height: 66px;">
									<ng-container *ngFor="let subAction of rulesSubActions | keyvalue: gs.returnZero">
										<!--CC: quiet filled pills - a row of outlined boxes read as noise next to the primary action-->
										<span *ngIf="selectedRulePreset[ruleType.key].actions.includes(subAction.value)"
										      style="font-size: 12px; background: var(--ui-surface-2); color: var(--ui-text-muted);"
										      class="rounded-3 py-1 px-2 text-center">
											{{subAction.value}}
										</span>
									</ng-container>
								</div>
								<div class="rounded-1 d-flex align-items-center justify-content-center px-2" style="border: 1px solid var(--ui-border); height: 28px; min-width: 135px; cursor: pointer;"
									*ngIf="selectedRulePreset?.name === dic.CONSTANTS.lfMainCustomizationName"
									(click)="openRetentionPeriodPopup(ruleType.key); $event.stopPropagation();">
									<a class="w-100 flex-row justify-content-between align-items-center text-nowrap">
										<span>{{selectedRulePreset[ruleType.key].retention_period || '14'}} days</span>
										<i class="far fa-pen text-muted" style="font-size: 10px;"></i>
									</a>
								</div>
								<div class="rounded-1 d-flex align-items-center justify-content-center flex-shrink-0 me-2 text-muted" style="width: 28px; height: 28px;">
									<i [ngClass]="expandedRuleType === ruleType.key ? 'far fa-chevron-up' : 'far fa-chevron-down'"></i>
								</div>
							</div>

							<div *ngIf="expandedRuleType === ruleType.key"
								class="animated fadeIn p-4 pt-3"
								style="border-top: 1px solid #dee2e6;"
								(click)="$event.stopPropagation()">
								<div class="fw-bold pb-2 mb-3 gradient-border-bottom">
									Secondary Actions
								</div>
								<div class="flex-row flex-wrap justify-content-start gap-4">
									<div *ngFor="let actionKey of rulesSubActions | keyvalue: gs.returnZero"
										style="min-width: 45%;"
										[hidden]="(ruleType.value === dic.CONSTANTS.tpRule.name.external && (actionKey.value === dic.CONSTANTS.tpRule.action.notifyRecipient || actionKey.value === dic.CONSTANTS.tpRule.action.notifyReviewer))"
										[ngClass]="{'disabled': ((enforceKeepRecord || ruleType.value === dic.CONSTANTS.tpRule.name.malicious || selectedRulePreset[ruleType.key].actions.includes(rulesMainActions.quarantine)) && actionKey.value === dic.CONSTANTS.tpRule.action.keepRecord) || (selectedRulePreset[ruleType.key].actions.includes(rulesMainActions.quarantine) && actionKey.value === dic.CONSTANTS.tpRule.action.releaseToFolder) || (!isMailServerConnected && actionKey.value === dic.CONSTANTS.tpRule.action.releaseToFolder && !selectedRulePreset[ruleType.key].actions.includes(rulesSubActions.releaseToFolder))}"
										[tooltip]="((ruleType.value === dic.CONSTANTS.tpRule.name.malicious || selectedRulePreset[ruleType.key].actions.includes(rulesMainActions.quarantine)) && actionKey.value === dic.CONSTANTS.tpRule.action.keepRecord) ? '&quot;Keep Record&quot; cannot be disabled for quarantined emails' : (!isMailServerConnected && actionKey.value === dic.CONSTANTS.tpRule.action.releaseToFolder && !selectedRulePreset[ruleType.key].actions.includes(rulesSubActions.releaseToFolder)) ? 'Either the Exchange or Google (Graph API) integration must be connected to use &quot;' + dic.CONSTANTS.tpRule.action.releaseToFolder + '&quot;' : (selectedRulePreset[ruleType.key].actions.includes(rulesMainActions.quarantine) && actionKey.value === dic.CONSTANTS.tpRule.action.releaseToFolder) ? '&quot;' + dic.CONSTANTS.tpRule.action.releaseToFolder + '&quot; is available only when the main action is &quot;' + rulesMainActions.release + '&quot;' : null">
										<div class="flex-row gap-3 align-items-center">
											<toggle-switch-c [id]="actionKey.key + '_' + ruleType.key"
												[model]="selectedRulePreset[ruleType.key].actions.includes(rulesSubActions[actionKey.key])"
												(onChange)="selectRulesAction(ruleType.key, actionKey.value)"
												[hideText]="true">
											</toggle-switch-c>
											<div class="flex-column gap-1" style="width: 240px; font-size: 14px;">
												<span class="fw-500">
													{{actionKey.value}}
													<!-- CC: taken from content.component.html -> isNewFeature "New" tag -->
													<span *ngIf="actionKey.value === dic.CONSTANTS.tpRule.action.releaseToFolder" class="new-page-btn align-self-center mx-1">New</span>
												</span>
												<span style="font-size: 0.92em; color: #888; line-height: 1.3;">{{subActionsDescriptions[actionKey.key]}}</span>
											</div>
											<ng-container *ngIf="selectedRulePreset[ruleType.key].actions.includes(rulesSubActions[actionKey.key])">
												<btn-c *ngIf="actionKey.key === 'addWarningLabel'"
													style="min-width: 0;" variant="text"
													(click)="$event.stopPropagation();"
													(action)="openModifyWarning(ruleType.key);">Configure</btn-c>
												<btn-c *ngIf="actionKey.key === 'addSubjectText'"
													style="min-width: 0;" variant="text"
													(click)="$event.stopPropagation();"
													(action)="openModifySubject(ruleType.key);">Configure</btn-c>
												<btn-c *ngIf="actionKey.key === 'recipientControl'"
													style="min-width: 0;" variant="text"
													(click)="$event.stopPropagation();"
													(action)="openRecipientPermissionsPopup(ruleType.key);">Configure</btn-c>
												<btn-c *ngIf="actionKey.key === 'releaseToFolder'"
													style="min-width: 0;" variant="text"
													(click)="$event.stopPropagation();"
													(action)="openModifyFolder(ruleType.key);">Configure</btn-c>
											</ng-container>
										</div>
									</div>
								</div>
								<div class="flex-row align-items-center gap-2 mt-1 px-2"
									*ngIf="ruleType.value === dic.CONSTANTS.tpRule.name.malicious && selectedRulePreset[ruleType.key].actions.includes(rulesSubActions.recipientControl) && selectedRulePreset[ruleType.key].options?.recipient_release_email">
									<i class="far fa-exclamation-triangle text-warning"></i>
									<span style="font-size: 0.92em;">Allowing recipients to release malicious emails may expose your network to serious threats</span>
								</div>
							</div>
						</div>
					</div>

					<div class="flex-row mt-4 mb-2 align-items-baseline gap-2" *ngIf="enforceKeepRecord">
						<i class="far fa-exclamation-triangle text-warning"></i>
						<span>{{enforceKeepRecord}}</span>
					</div>
				</div>
			</div>
		</div>

		<!--CC: section label - separates the per-category rules from the advanced behavior toggles below-->
		<div class="w-100 px-1 pt-2" style="font-size: 11.5px; font-weight: 600; letter-spacing: 0.4px; text-transform: uppercase; color: var(--ui-text-muted); max-width: 1200px;">
			Advanced Actions
		</div>

		<div class="list-group-item settings-list-item" style="z-index: 10;">
			<div class="title-section-container flex-column gap-2">
				<b>Release malicious emails with defanged links</b>
				<span class="lh-base" style="font-size: 0.9em;">
                    Emails that are detected as malicious based <b>only</b> on link metrics will be automatically released and any malicious links will be defanged
				</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="auto_release_malicious_urls_defang"
								 [(model)]="config?.threat_protection.auto_release_malicious_urls_defang.enabled"
								 (onChange)="updateAutoReleaseMaliciousUrlsDefangStatus();">
				</toggle-switch-c>
				<div class="flex-row align-items-center gap-2" [ngClass]="{'disabled-overlay' : !config?.threat_protection.auto_release_malicious_urls_defang.enabled}">
					<span>Only for known contacts</span>
					<toggle-switch-c id="auto_release_malicious_urls_defang.only_for_known_contacts"
									 [(model)]="config?.threat_protection.auto_release_malicious_urls_defang.only_for_known_contacts"
									 [isDisabled]="!config?.threat_protection.auto_release_malicious_urls_defang.enabled"
									 (onChange)="updateAutoReleaseMaliciousUrlsDefangStatus();">
					</toggle-switch-c>
				</div>
			</div>
		</div>

		<!--Settings: Configure time-based notifications for received threats-->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>Configure time-based notifications for received threats</b>
				<span class="lh-base" style="font-size: 0.9em;">Configure when reviewers and recipients should receive email notifications for received threats.</span>
			</div>
			<div class="content-container flex-column gap-2">
				<btn-c style="width: 150px;"
					   (action)="openNotifyOptions();">
					Notification Options
				</btn-c>
			</div>
		</div>

		<!--Settings: Skip warning label for email/domain-->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>Skip warning label for email/domain</b>
				<span class="lh-base" style="font-size: 0.9em;">Warning labels will never be applied to emails and domains from this list.</span>
			</div>
			<div class="content-container flex-column gap-2">
				<btn-c style="width: 150px;"
					   (action)="openExcludeDomainsEmailsPopup();">
					Configure
				</btn-c>
			</div>
		</div>

		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>Notify about user reports</b>
				<span class="lh-base" style="font-size: 0.9em;">Reviewers will receive an automated notification when a user reports an email as malicious/spam/safe. Reviewers will be able to review the reported email and take actions.</span>
			</div>
			<div class="content-container flex-column gap-3">
				<div>
					<toggle-switch-c id="send_user_reports_to_reviewers"
									 [(model)]="mainRulePreset.send_user_reports_to_reviewers"
									 (onChange)="updateSendUserReportsToReviewers()">
					</toggle-switch-c>
				</div>

				<div class="flex-row gap-2 align-items-center">
					<span>Exclude emails reported as safe</span>
					<toggle-switch-c id="skip_safe_send_user_reports_to_reviewers"
									 [hideText]="true"
									 [isDisabled]="!mainRulePreset.send_user_reports_to_reviewers"
									 [(model)]="mainRulePreset.skip_safe_send_user_reports_to_reviewers"
									 (onChange)="updateSendUserReportsToReviewers()">
					</toggle-switch-c>
				</div>
			</div>
		</div>

		<div class="list-group-item settings-list-item" *ngIf="mainRulePreset?.send_user_reports_to_reviewers">
			<div class="title-section-container flex-column gap-2">
				<!--CC: the card had no title and looked broken next to its siblings (QA)-->
				<b>Additional report recipients</b>
				<span class="lh-base" style="font-size: 0.9em;">Send user report notifications also to these email addresses, in addition to reviewers.</span>
			</div>
			<div class="content-container flex-column gap-2">
				<div class="flex-row hSpace05">
					<input type="text" style="width: 80%; max-width: 300px; margin-bottom: unset;"
						   placeholder="Add email address here"
						   (keyup.enter)="userReportRecipientModel && !userReportRecipientsActionInProcess && updateUserReportNotificationRecipients(dic.CONSTANTS.actions.add);"
						   [(ngModel)]="userReportRecipientModel">
					<btn-c style="min-width: 0;" endIcon="zmdi zmdi-check"
						   [isDisabled]="!userReportRecipientModel || userReportRecipientsActionInProcess"
						   (action)="updateUserReportNotificationRecipients(dic.CONSTANTS.actions.add);">
					</btn-c>
				</div>
				<div class="flex-column animated fadeIn gap-1 pe-2 overflow-auto" style="max-width: 400px; max-height: 200px;"
					 *ngIf="mainRulePreset.user_report_notification_emails?.length">
					<div *ngFor="let recipient of mainRulePreset.user_report_notification_emails;">
						<div class="name ellipsis" style="width: 95%; display: inline-block; max-width: 800px;">{{recipient}}</div>
						<a class="closeRed action"
						   (click)="updateUserReportNotificationRecipients(dic.CONSTANTS.actions.delete, recipient)"
						   [disabled]="userReportRecipientsActionInProcess"
						   [ngClass]="userReportRecipientsActionInProcess ? 'closeRed disableAction' : 'approveGreen'">
							<i class="far fa-times"></i>
						</a>
					</div>
				</div>
			</div>
		</div>

		<!--Settings: Apply "Scanned by Inbound Shield" footer-->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>Apply "Scanned by Inbound Shield" footer</b>
				<span class="lh-base" style="font-size: 0.9em;">When enabled, a footer will be applied to all emails to indicate the email has been scanned by Inbound Shield.</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="applyFooterToggle"
								 [(model)]="config.threat_protection.add_footer"
								 (onChange)="updateFooterStatus()">
				</toggle-switch-c>
				<div class="flex-row align-items-center gap-2" [ngClass]="{'disabled-overlay' : !config.threat_protection.add_footer}"
					 (ngInit)="newCustomizedFooterStr = config.threat_protection.customization_footer;">
					<span>Customized footer:</span>
					<input type="text" class="f-1-0"
						   [disabled]="!config.threat_protection.add_footer"
						   placeholder='Default: "This email has been scanned by Inbound Shield"'
						   [(ngModel)]="newCustomizedFooterStr"/>
					<btn-c (action)="updateFooterContent();">
						Update
					</btn-c>
				</div>
			</div>
		</div>

		<!--Settings: Suspicious toggles -->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>Set impersonation emails as "Suspicious"</b>
				<span class="lh-base" style="font-size: 0.9em;">Emails detected for these types of impersonation attacks will be flagged as "Suspicious" instead of "Malicious".</span>
			</div>
			<div class="content-container">
				<div class="list-group list-group-flush">
					<div class="list-group list-group-flush">
						<div class="list-group-item flex-row py-3 px-0">
							<div class="flex-column gap-2" style="flex-basis: 245px; flex-shrink: 0;">
								<span>Contact impersonation</span>
							</div>
							<toggle-switch-c *ngIf="mainRulePreset" id="contact_impersonation_suspicious"
											 [(model)]="mainRulePreset.contact_impersonation_suspicious"
											 (onChange)="updateImpersonationSuspicious('contact_impersonation_suspicious' ,dic.CONSTANTS.rulesTpAction.contactImpersonation)">
							</toggle-switch-c>
						</div>
						<div class="list-group-item flex-row py-3 px-0">
							<div class="flex-column gap-2" style="flex-basis: 245px; flex-shrink: 0;">
								<span>User impersonation</span>
							</div>
							<toggle-switch-c *ngIf="mainRulePreset" id="user_impersonation_suspicious"
											 [(model)]="mainRulePreset.user_impersonation_suspicious"
											 (onChange)="updateImpersonationSuspicious('user_impersonation_suspicious' ,dic.CONSTANTS.rulesTpAction.userImpersonation)">
							</toggle-switch-c>
						</div>
						<div class="list-group-item flex-row py-3 px-0">
							<div class="flex-column gap-2" style="flex-basis: 245px; flex-shrink: 0;">
								<span>Mailbox impersonation</span>
							</div>
							<toggle-switch-c *ngIf="mainRulePreset" id="mailbox_impersonation_suspicious"
											 [(model)]="mainRulePreset.mailbox_impersonation_suspicious"
											 (onChange)="updateImpersonationSuspicious('mailbox_impersonation_suspicious' ,dic.CONSTANTS.rulesTpAction.mailboxImpersonation)">
							</toggle-switch-c>
						</div>
						<div class="list-group-item flex-row py-3 px-0">
							<div class="flex-column gap-2" style="flex-basis: 245px; flex-shrink: 0;">
								<span>Brand impersonation</span>
							</div>
							<toggle-switch-c *ngIf="mainRulePreset" id="brand_impersonation_suspicious"
											 [(model)]="mainRulePreset.brand_impersonation_suspicious"
											 (onChange)="updateImpersonationSuspicious('brand_impersonation_suspicious' ,dic.CONSTANTS.rulesTpAction.mailboxImpersonation)">
							</toggle-switch-c>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!--Modify warning label popup-->
<popup-c class="no-content-padding show-in-o-wizard" *ngIf="modifyWarningLabelPopup?.show"
		 head="Modify Warning Label for {{modifyWarningLabelPopup.ruleType}} source"
		 (closeCb)="modifyWarningLabelPopup = null"
		 size="large" width="1400px" height="720px">
	<div class="flxRow f-1-0 gap-2" style="overflow: auto; padding: 25px;">
		<div class="flex-column w-100">
			<!--warning text-->
			<div class="flxRow">
				<div class="flxClmn vSpace1" style="flex-basis: 120px; flex-shrink: 0;">
					<label style="font-weight: bold;">
						Warning text
					</label>
				</div>
				<div class="flex-column gap-1" style="max-width: 500px; z-index: 9999;">
					<div style="flex:1 0; overflow: auto; box-sizing: border-box; border: 1px solid #ccc; vertical-align: top; resize: none;"
						 [ngxSummernote]="summernoteConfig" [(ngModel)]="modifyWarningLabelPopup.text" (ngModelChange)="warningLabelTextChanged()"></div>
					<div class="flex-row gap-1">
						<i class="far fa-info-circle text-info"></i>
						<span ngNonBindable>Enhance your warning label by adding dynamic fields such as {{SENDER_EMAIL}}, {{SENDER_NAME}}, {{REPLY_TO_EMAIL}}, and {{THREAT_SUB_CATEGORY}}.</span>
					</div>
				</div>
			</div>
			<!--warning color-->
			<div class="flxRow" style="padding-top: 20px;">
				<div style="overflow: hidden; float: left; flex-basis:120px;">
					<label style="font-weight: bold;">
						Warning color
					</label>
				</div>
				<div style="flex: 1 0;">
					<div class="flxRow hSpace1" style="align-items: baseline; margin-bottom: 15px; color: var(--bs-warning);" *ngIf="gs.userInfo?.dark_mode">
						<i class="far fa-exclamation-triangle "></i>
						<span>While in "Dark Mode", color picker will show inaccurate colors.</span>
					</div>
					<div class="flxRow w100 hSpace3 color-picker-css" style="align-items: center;">
						<div class="flxClmn-center vSpace2" style="align-items: center;">
							<div style="width: 40px; height: 40px;">
								<div class="w100 h100 static-color" style="border-radius: 50%;"
									 [ngStyle]="{'background' : '#' + modifyWarningLabelPopup.color.replace('#','')}"
									 *ngIf="modifyWarningLabelPopup.color.replace('#','').length === 6">
								</div>
							</div>
							<div class="flxClmn vSpace05">
								<input type="text" style="width: 90px; margin: 0;"
									   [ngClass]="{'validation-error' : hexInputError}"
									   (keyup)="hexInputChanged();"
									   [value]="'#' + modifyWarningLabelPopup.color.replace('#','')"
									   [(ngModel)]="modifyWarningLabelPopup.color">
								<span style="opacity: 0.65; font-family: 'Roboto Condensed', sans-serif; letter-spacing: 0.5px;">Color Hex<br/>(6 digits only)</span>
							</div>
						</div>
						<span [(colorPicker)]="modifyWarningLabelPopup.color"
							  [cpPosition]="'bottom'" [cpPositionOffset]="'50%'" [cpWidth]="'175px'"
							  [cpOutputFormat]="'hex'"
							  [cpDialogDisplay]="'inline'"
							  [cpDisableInput]="true"
							  [cpToggle]="true"
							  (cpSliderDragEnd)="hexInputError = false;"
							  [style.position]="'relative'"></span>
					</div>
				</div>
			</div>
			<!--Allow reporting-->
			<div class="flxRow" style="padding-top: 20px;">
				<div style="overflow: hidden; float: left; flex-basis:120px;">
					<label style="font-weight: bold;">
						Allow reporting
					</label>
				</div>
				<div class="flxClmn vSpace1" style="flex: 1 0;">
					<checkbox *ngIf="modifyWarningLabelPopup.ruleType !== dic.CONSTANTS.tpRule.name.malicious"
							  id="report_malicious" [(model)]="modifyWarningLabelPopup.report_malicious">
						Allow recipients to report emails as <b>malicious</b> directly from the warning label
					</checkbox>
					<checkbox id="report_safe" [(model)]="modifyWarningLabelPopup.report_safe">
						Allow recipients to report emails as <b>safe</b> and allowlist the sender and links directly from the warning label
					</checkbox>
					<div class="flex-row mx-2 align-items-baseline gap-2" *ngIf="config.outbound_relay?.enabled">
						<i class="far fa-info-circle text-info"></i>
						<span>If "Allow reporting" is enabled, records will be kept for this type of email</span>
					</div>
					<div class="flex-row mx-2 align-items-baseline gap-2" *ngIf="!config.outbound_relay?.enabled">
						<i class="far fa-exclamation-triangle text-warning"></i>
						<span>Allow reporting will only work if Outbound Email Relay is configured</span>
					</div>
				</div>
			</div>
		</div>
		<!--Mail preview (warning label preview)-->
		<div class="flex-column gap-3 w-100">
			<div class="flex-column gap-2 border border-primary rounded p-3 shadow">
				<span class="fw-bold mb-2">Email preview</span>
				<div class="flex-row gap-2 align-items-start w-100">
					<div class="border d-flex centralize overflow-hidden" style="border-radius: 50%; width: 40px; height: 40px; opacity: 0.5;">
						<img [src]="userInfo.picture" class="w-100" alt="profile picture">
					</div>
					<div class="flex-column gap-2 f-1-0">
						<div class="flex-row align-items-center justify-content-between" style="opacity: 0.5;">
							<span>{{userInfo.name}}</span>
							<div class="flex-row gap-3 align-items-center">
								<i class="far fa-sun" style="color: #486db5;"></i>
								<i class="far fa-smile" style="color: #486db5;"></i>
								<div class="flex-row align-items-center gap-1">
									<i class="far fa-reply" style="color: #881798;"></i>
									<span>Reply</span>
								</div>
								<div class="flex-row align-items-center gap-1">
									<i class="far fa-reply-all" style="color: #881798;"></i>
									<span>Reply all</span>
								</div>
								<div class="flex-row align-items-center gap-1">
									<i class="far fa-share" style="color: #881798;"></i>
									<span>Forward</span>
								</div>
								<i class="fas fa-ellipsis-h"></i>
							</div>
						</div>
						<div class="flex-row align-items-center justify-content-between" style="opacity: 0.5;">
							<span>To: <i class="far fa-clock" style="color: #eaa300;"></i> {{gs.corpname}}</span>
							<span>Wed 6/4/2025 16:20 PM</span>
						</div>
						<!--warning label-->
						<div class="flxClmn f-1-0" style="overflow: auto;">
							<div class="flxClmn f-1-0" style="overflow: auto;">
								<div class="flex-column gap-3" style="border-left : solid 4px; padding: 10px 20px; font-family: 'Arial', 'sans-serif';"
									 [ngStyle]="{'background-color': '#' + modifyWarningLabelPopup.color.replace('#','') + '4d', 'border-color': '#' + modifyWarningLabelPopup.color.replace('#','')}">
									<span style="font-size: 14px;" [innerHTML]="modifyWarningLabelPopup.sanitizedText"></span>
									<div class="animated fadeIn flex-row gap-3" *ngIf="modifyWarningLabelPopup.report_malicious || modifyWarningLabelPopup.report_safe">
										<btn-c *ngIf="modifyWarningLabelPopup.report_safe"
											   class="warning-label-preview-btn" style="width: 140px; background: #ffffff; pointer-events: none; cursor: default; font-size: 13px;"
											   variant="outlined" color="black">
											<b>Trust Email</b>
										</btn-c>
										<btn-c class="warning-label-preview-btn" style="width: 140px; background: #ffffff; pointer-events: none; cursor: default; font-size: 13px;"
											   *ngIf="modifyWarningLabelPopup.report_malicious && modifyWarningLabelPopup.ruleType !== dic.CONSTANTS.tpRule.name.malicious"
											   variant="outlined" color="black">
											<b>Report Email</b>
										</btn-c>
									</div>
								</div>
							</div>
						</div>

						<div style="opacity: 0.5;">
							<p>This is a sample message to illustrate how the warning label integrates with your email content. The actual message content will appear here</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="flxRow-end  hSpace1" style="padding: 25px;">
		<btn-c class="popup-action-btn"
			   variant="text" color="goldenrod"
			   [isDisabled]="modifyWarningLabelPopup.modifyWarningInProcess"
			   (action)="resetWarningLabel()">
			Reset to default
		</btn-c>
		<btn-c class="popup-action-btn"
			   variant="outlined"
			   [isDisabled]="modifyWarningLabelPopup.modifyWarningInProcess"
			   (action)="modifyWarningLabelPopup = null;">
			Cancel
		</btn-c>
		<btn-c class="popup-action-btn"
			   [isDisabled]="!modifyWarningLabelPopup.text || !modifyWarningLabelPopup.color || modifyWarningLabelPopup.modifyWarningInProcess"
			   (action)="modifyWarning(false)">
			Apply
		</btn-c>
	</div>
</popup-c>

<!--Modify subject popup-->
<popup-c *ngIf="modifySubjectPopup?.show"
		 class="show-in-o-wizard"
		 head="Modify Subject Text for {{modifySubjectPopup.ruleType}}"
		 (closeCb)="modifySubjectPopup = null"
		 (confirmCb)="modifySubject()"
		 [buttons]="{confirm: {text: 'Confirm', loading: modifySubjectPopup.modifySubjectInProcess}}"
		 size="dynamic">
	<div class="flxClmn f-1-0 vSpace1" style="overflow: auto;">
		<span>The relevant text will be added to the beginning of email subject when it is released</span>
		<br/>
		<input type="text" style="width: 100%;" [(ngModel)]="modifySubjectPopup.text" placeholder="Subject">
	</div>
</popup-c>

<!--Modify folder popup-->
<popup-c *ngIf="modifyFolderPopup?.show"
         class="show-in-o-wizard"
         head="Move to Folder - {{_.capitalize(modifyFolderPopup.ruleType)}}"
         (closeCb)="modifyFolderPopup = null"
         (confirmCb)="modifyFolder()"
         [buttons]="{confirm: {text: 'Confirm', loading: modifyFolderPopup.modifyFolderInProcess}}"
         size="dynamic">
	<div class="flxClmn f-1-0 vSpace1" style="overflow: auto;">
		<span>Emails will be moved to the mailbox folder you specify below. If the folder doesn't already exist, we'll create it automatically.</span>
		<br/>
		<input type="text" style="width: 100%;" [(ngModel)]="modifyFolderPopup.text" placeholder="Folder">
	</div>
</popup-c>

<!--CC: notification options popup extracted to notification-options-component -->
<notification-options-component *ngIf="notifyOptionsPopup?.show"
								[mainRulePreset]="mainRulePreset"
								(closeCb)="notifyOptionsPopup = null">
</notification-options-component>

<!--Skip warning label popup-->
<popup-c *ngIf="excludeDomainsEmailsPopup?.show"
		 head="Skip Warning Label for Email/Domain"
		 class="show-in-o-wizard"
		 (closeCb)="excludeDomainsEmailsPopup = null"
		 (confirmCb)="changeExcludeDomainsEmails()"
		 [buttons]="{confirm: {text: 'Confirm', loading: excludeDomainsEmailsPopup.changeExcludeDomainsEmailsInProcess}}"
		 size="medium">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<span>Create a list of emails and domains that the warning label will not appear for in incoming emails:</span>
		<div class="flex-column f-1-0 overflow-auto gap-2 p-2">
			<div class="position-relative f-1-0 mt-3  flex-column overflow-auto">
				<trustifi-table-c
					class="trustifi-table f-1-0" style="z-index: 5;"
					[list]="excludeDomainsEmailsPopup.emails"
					[headers]="[
                                    {text: 'Email/Domain', sortKey: 'value'}
                                ]"
					[cellsPrototype]="[
                                          {textKey: 'value', edit: {modelKey: 'value', placeholder: 'Email/Domain'}},
                                      ]"
					[cellActions] = "{
                                        enable: true,
                                        selectItemActionCb:	selectExcludedEmailAction,
                                        initActionsFunction: showExcludedEmailActions
                                    }"
					(searchFunction)="searchExcludedEmail($event.searchTerm, $event.activeFilters)"
					(confirmEditFunction)="confirmAddExcludedEmail($event.item ,$event.isApproved)"
					[options]="{
                                    defaultSortKey: '-value'
                                }"
				>
					<div tableButtons>
						<div class="flxRow hSpace05">
							<btn-c [isDisabled]="addExcludedEmailActive"
								   endIcon="far fa-plus"
								   (action)="startAddExcludedEmail();">
								Add Email/Domain
							</btn-c>
						</div>
					</div>
				</trustifi-table-c>
			</div>
		</div>
	</div>
</popup-c>

<!--Change Retention period popup-->
<popup-c *ngIf="retentionPeriodPopup?.show"
		 head="Change Retention Period"
		 class="show-in-o-wizard"
		 (closeCb)="retentionPeriodPopup.show = false"
		 (confirmCb)="changeRetentionPeriod(retentionPeriodPopup.newRetentionPeriod)"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: retentionPeriodPopup.retentionPeriodInProcess}}"
		 size="dynamic">
	<div class="flxClmn f-1-0 vSpace3">
		<span>Determine how long quarantined emails of the type <b style="text-transform: capitalize;">{{retentionPeriodPopup.type}}</b>, should be kept by {{corpname}}.</span>

		<div class="flxRow hSpace2" style="align-items: center; flex: 1 0;">
			<span><b>Change retention period to</b>:</span>
			<input style="text-align: center;" type="number" min="1" max="180" step="1" pattern="^\d*(\.\d{0,3})?$" placeholder="Days"
				   [(ngModel)]="retentionPeriodPopup.newRetentionPeriod">
			<span>days.</span>
		</div>

		<span>You can choose to preserve specific emails by selecting "Preserve record" for an email in the <a class="blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.quarantined]">"Quarantined emails"</a> page.</span>
	</div>
</popup-c>

<popup-c class="bs-enabled" *ngIf="deleteQuarantinedEmailRecPopup?.show"
         class="show-in-o-wizard"
		 head="Delete Quarantined Email Records" size="dynamic"
		 (closeCb)="deleteQuarantinedEmailRecPopup.show = false;"
		 (confirmCb)="deleteQuarantinedEmailRecPopup?.doneCb()"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Delete', disabled: deleteQuarantinedEmailRecPopup.applyInProcess || deleteQuarantinedEmailRecPopup.verifyEmail !== userInfo.email}}">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<div class="d-flex gap-1 text-danger pt-2" style="font-size: 14px;">
			<i class="zmdi zmdi-alert-circle-o" style="font-size: 1.5rem; margin-top: -6px;"></i>
			{{deleteQuarantinedEmailRecPopup.subTitle}}
		</div>

		<ul>
			<li>Deleted quarantined emails records can not be restored</li>
		</ul>

		<div class="align-items-center flex-row gap-3">
			<div>Email:</div>
			<input type="text" placeholder="Please enter your email address for further verification"
				   style="width:330px;" [required]="true"
				   [(ngModel)]="deleteQuarantinedEmailRecPopup.verifyEmail"
				   [ngStyle]="deleteQuarantinedEmailRecPopup.verifyEmail && deleteQuarantinedEmailRecPopup.verifyEmail !== userInfo.email ? {'border-color':'red'} : {}"/>
		</div>
	</div>
</popup-c>

<popup-c *ngIf="addSubRulePopup?.show"
         class="show-in-o-wizard"
		 [head]="addSubRulePopup.sourcePreset ? 'Clone Threat Prevention Rules Preset' : 'Add Threat Prevention Rules Preset'" size="dynamic"
		 (closeCb)="addSubRulePopup = null"
		 (confirmCb)="addSubRule();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: addSubRulePopup.addSubRuleInProcess}}">
	<div class="flex-column gap-3 f-1-0">

		<span>Enter a name for the {{addSubRulePopup.sourcePreset ? 'cloned' : 'new'}} Threat Prevention rules preset:</span>
		<input type="text" style="margin: 0; width: 250px;" placeholder="Name"
			   (keyup)="addSubRulePopup.error = false;"
			   [(ngModel)]="addSubRulePopup.name"
			   [ngClass]="{'validation-error' : addSubRulePopup.error}"/>
		<br *ngIf="!addSubRulePopup.sourcePreset"/>
		<div class="flex-row gap-2 align-items-center bg-light border rounded-1 px-3 py-2 mt-3 mb-1"
			 *ngIf="addSubRulePopup.sourcePreset">
			<span>Cloning from</span>
			<i class="far fa-long-arrow-alt-right opacity-75 text-muted" style="font-size: 17px;"></i>
			<span class="fw-bold">{{addSubRulePopup.sourcePreset.name}}</span>
		</div>
		<span>Custom Threat Prevention rules presets can be used by creating an Inbound Email rule with the action "Apply Custom Threat Prevention Rules"</span>
	</div>
</popup-c>

<popup-c *ngIf="recipientPermissionsPopup?.show"
		 head="Modify Recipient Permissions"
		 class="bs-enabled show-in-o-wizard"
		 subTitle="Configure recipient permissions for {{recipientPermissionsPopup.ruleType}} emails"
		 (closeCb)="recipientPermissionsPopup = null;"
		 size="dynamic">

	<div class="flxClmn gap-4">
		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>View Threat Analysis</b>
				<span>Allow recipient to view the email threat analysis</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="threat_analysis"
								 [hideText]="true"
								 [isDisabled]="true"
								 [(model)]="recipientPermissionsPopup.threat_analysis"></toggle-switch-c>
			</div>
		</div>

		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>View Content</b>
				<span>Allow recipient to view the email content for quarantined emails</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="recipient_view_content"
								 [hideText]="true"
								 [(model)]="selectedRulePreset[recipientPermissionsPopup.ruleType].options.recipient_view_content"
								 (onChange)="updateRecipientPermissions('recipient_view_content')"></toggle-switch-c>
			</div>
		</div>

		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>Release emails</b>
				<span>Allow recipient to release emails</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="recipient_release_email"
								 [hideText]="true"
								 [(model)]="selectedRulePreset[recipientPermissionsPopup.ruleType].options.recipient_release_email"
								 (onChange)="updateRecipientPermissions('recipient_release_email')"></toggle-switch-c>
			</div>
		</div>

	</div>
</popup-c>
